<script lang="ts" setup>
import AppModal from "@/components/AppModal.vue";
import CreateProfileForm from "@/features/profiles/CreateProfileForm.vue";
import type { Profile } from "~/common/types/types";

const profile = defineModel({
  required: true,
  type: Object as PropType<Profile>   
})

const emit = defineEmits(["close", "submitted"]);

function closed() {
    emit("close");
}

function submitted(profile: Profile) {
  emit("submitted", profile);
  closed();
}

</script>
<template>
  <AppModal @close="closed">
    <template #title> Create Profile </template>
    <template #body>
      <CreateProfileForm @submitted='submitted' v-model="profile" />
    </template>
  </AppModal>
</template>